export default "__VITE_ASSET__mERDb8HY__"